import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Switch, Route } from 'react-router-dom';

import { UserProvider } from '@magoosh/context/user_context';
import { UserContextInterface } from '@magoosh/context/user_context/types';
import { ModalProvider } from '@magoosh/context/modal_context';

import Router from '@magoosh/lib/router';
import routes from './routes';

const queryClient = new QueryClient();

interface Props {
  initialData?: any;
  url: string;
  userInfo: UserContextInterface;
}

const App: React.FC<Props> = (props) => {  
  if (props.initialData) {
    Object.keys(props.initialData).forEach((key) => {
      queryClient.setQueryData(key, props.initialData[key])
    })
  }

  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider initialData={props.userInfo}>
        <ModalProvider>
          <Router location={props.url}>
            <Switch>
              {
                routes.map((route, idx) => {
                  return <Route {...route} key={idx} />
                })
              }
            </Switch>
          </Router>
        </ModalProvider>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
